"use client";

import { Button } from "uiShadcn/button";
import * as Sentry from "@sentry/nextjs";
import Filehuman from "assets/images/filehuman.svg";
import { catchError, type ErrorInfo } from "next/error";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import ErrorBaseTemplate from "templates/ErrorBaseTemplate";

function FormErrorFallback(_props: object, { error, retry }: ErrorInfo) {
    const { formatMessage } = useIntl();

    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <ErrorBaseTemplate
            title={formatMessage({ id: "something_went_wrong" })}
            description={formatMessage({ id: "something_went_wrong_desc" })}
        >
            <Button
                type="button"
                dataTestId="button_try_again"
                onClick={() => retry()}
                variant="destructive"
                className="w-full md:max-w-[256px]"
            >
                {formatMessage({ id: "try_again" })}
            </Button>
            <div className="pt-n16">
                <Filehuman aria-hidden="true" />
            </div>
        </ErrorBaseTemplate>
    );
}

export default catchError(FormErrorFallback);
